import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { activarAvisos, alTocarAviso, pedirDestinoPendiente, iniciarPresencia, instalada, prepararAvisos, pushSoportado, sincronizarAvisos } from "./appMovil";
import "./appMovil.css";


// iPhone con WAPP instalada: la franja de la rayita de abajo no la reporta el iPhone (sin viewport-fit=cover, que en iOS 26
// rompía el teclado: la caja de escribir saltaba hasta arriba; video de Esteban 2026-10-10). Se marca y el CSS deja el espacio.
try {
	const iphone = /iP(hone|od)/.test(navigator.userAgent);
	if (iphone && instalada() && window.screen.height >= 812) document.documentElement.classList.add("ios-app");
} catch { /* nada */ }

//Con el dominio: el permiso de avisos es por dominio y el puente copió la marca de app.washingtonacademy.mx (2026-10-21).
const HOJA_KEY = "wapp.hojaAvisos." + window.location.hostname;
const HOJA_CADA_MS = 7 * 24 * 3600 * 1000;

const hojaPendiente = (): boolean => {
	if (!instalada() || !pushSoportado() || Notification.permission !== "default") return false;
	try {
		return Date.now() - Number(localStorage.getItem(HOJA_KEY) || 0) > HOJA_CADA_MS;
	} catch {
		return true;
	}
};

/**
 * Lo de la app instalada que vive en toda WAPP (va dentro de App, con sesión):
 * - al tocar un aviso con WAPP abierta, navega ahí sin recargar;
 * - "la tengo a la vista" para que no lleguen push repetidos;
 * - renueva la suscripción de avisos con la sesión nueva;
 * - en la app instalada, una sola vez (y luego cada 7 días si dice "Ahora No"), la hoja "Activa los Avisos".
 */
const AppMovilGlobal: React.FC<{ authenticated: boolean }> = ({ authenticated }) => {
	const navigate = useNavigate();
	const [hoja, setHoja] = useState<boolean>(false);
	const [ocupado, setOcupado] = useState<boolean>(false);

	useEffect(() => {
		alTocarAviso((url) => navigate(url));
		// Al abrir la app y cada vez que vuelve a primer plano: si se tocó un aviso, ir a esa conversación.
		// Al tocar el aviso, la app puede despertar antes de que el service worker guarde el destino: se mira unas veces.
		const mirar = () => [0, 700, 1600, 3500].forEach((ms) => setTimeout(pedirDestinoPendiente, ms));
		mirar();
		const alVolver = () => { if (document.visibilityState === "visible") mirar(); };
		document.addEventListener("visibilitychange", alVolver);
		window.addEventListener("pageshow", alVolver);
		return () => { alTocarAviso(null); document.removeEventListener("visibilitychange", alVolver); window.removeEventListener("pageshow", alVolver); };
	}, [navigate]);

	useEffect(() => {
		if (!authenticated) return;
		iniciarPresencia();
		sincronizarAvisos();
		if (hojaPendiente()) {
			prepararAvisos();
			const t = setTimeout(() => setHoja(true), 1200);
			return () => clearTimeout(t);
		}
	}, [authenticated]);

	if (!hoja) return null;
	const cerrar = () => {
		try { localStorage.setItem(HOJA_KEY, String(Date.now())); } catch { /* nada */ }
		setHoja(false);
	};
	return (
		<div className="am-hoja-fondo" onClick={cerrar}>
			<div className="am-hoja" role="dialog" aria-label="Activa los Avisos" onClick={(e) => e.stopPropagation()}>
				<h2>Activa los Avisos</h2>
				<p>Te llegan los mensajes aunque WAPP esté cerrada.</p>
				<div className="am-hoja-botones">
					<button className="am-btn am-btn-texto" onClick={cerrar}>Ahora No</button>
					<button className="am-btn" disabled={ocupado} onClick={async () => {
						setOcupado(true);
						try { await activarAvisos(); } catch { /* lo intenta en WAPP en tu Celular */ }
						setOcupado(false);
						cerrar();
					}}>Activar Avisos</button>
				</div>
			</div>
		</div>
	);
};

export default AppMovilGlobal;
